import {
  Box,
  Card,
  CardContent,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
// import DayLessons from "../components/Lessons/DayLesson";
import { useEffect, useState } from "react";
import getLessonsByClub from "./getLessonsByClub";
import IndividualLesson from "../Lessons/IndividualLesson";
import IndividualGame from "./IndividualGame";
import getProMapping from "../Signups/getProMapping";
import IndividualTournament from "./IndividualTournament";

/** @param {any} props */
export function GameOrLessonCard({
  lesson_day,
  lesson,
  setLessonDeleteMessage,
  setLessonToDeleteId,
  managerMode,
  setEventId,
  setLessonPro,
  setLessonPrice,
  setGameDelete,
  setGameToDelete,
  clubId,
  setClubId,
  setLeasePrice,
  setGameDate,
  setGamePoloType,
  setGameDivisions,
  weekAtAGlance,
  setEventToEdit,
  setUpdateModal,
  setUpdateLessonModal,
  selectedEventTypes,
  showOnlyBookedLessons,
  setDisplayTournamentModal,
  setEventDetails,
  clubBadge,
}) {
  if (
    lesson.event_type === "lesson" &&
    (weekAtAGlance ||
      selectedEventTypes.some((event) => event.type === "Lessons"))
  ) {
    return (
      <Stack key={lesson.id}>
        <IndividualLesson
          key={lesson.id}
          lesson={lesson}
          setLessonDeleteMessage={setLessonDeleteMessage}
          setLessonToDeleteId={setLessonToDeleteId}
          managerMode={managerMode}
          setEventId={setEventId}
          setLessonPro={setLessonPro}
          setLessonPrice={setLessonPrice}
          clubId={clubId}
          setClubId={setClubId}
          setGameDate={setGameDate}
          weekAtAGlance={weekAtAGlance}
          showOnlyBookedLessons={showOnlyBookedLessons}
          setLessonToEdit={setEventToEdit}
          setUpdateLessonModal={setUpdateLessonModal}
          clubBadge={clubBadge}
        />
      </Stack>
    );
  } else if (
    lesson.event_type === "game" &&
    (weekAtAGlance ||
      selectedEventTypes.some((event) => event.type === "Games"))
  ) {
    return (
      <Stack key={lesson.id}>
        <IndividualGame
          key={lesson.id}
          game={lesson}
          setGameDelete={setGameDelete}
          setGameToDelete={setGameToDelete}
          managerMode={managerMode}
          setEventId={setEventId}
          clubId={clubId}
          setClubId={setClubId} 
          setLeasePrice={setLeasePrice}
          setGameDate={setGameDate}
          setGamePoloType={setGamePoloType}
          setGameDivisions={setGameDivisions}
          weekAtAGlance={weekAtAGlance}
          setGameToEdit={setEventToEdit}
          setUpdateModal={setUpdateModal}
          clubBadge={clubBadge}
        />
      </Stack>
    );
  } else if (
    lesson.event_type === "tournament_league" &&
    (weekAtAGlance ||
      selectedEventTypes.some((event) => event.type === "Tournaments"))
  ) {
    return (
      <IndividualTournament
        key={lesson.tournament_id}
        tournament={lesson}
        managerMode={managerMode}
        setEventId={setEventId}
        clubId={clubId}
        setClubId={setClubId}
        setLeasePrice={setLeasePrice}
        setGameDate={setGameDate}
        setEventToEdit={setEventToEdit}
        setGamePoloType={setGamePoloType}
        setDisplayTournamentModal={setDisplayTournamentModal}
        setEventDetails={setEventDetails}
        weekAtAGlance={weekAtAGlance}
        clubBadge={clubBadge}
      />
    );
  }
  return null;
}

export function NoUpcomingEvents({ managerMode, compact }) {
  const isManager = managerMode === -1;
  return (
    <Box
      data-testid="no-upcoming-events"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 1,
        py: compact ? 2 : 5,
        px: 3,
        borderRadius: 3,
        bgcolor: "background.paper",
        border: "1px dashed",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.4),
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          mb: 1,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "primary.main",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
        }}
      >
        <EventAvailableOutlinedIcon />
      </Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        No upcoming events
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {isManager
          ? "Nothing is scheduled for these dates yet. Create a game, lesson or tournament and it will show up here."
          : "Nothing is scheduled for these dates yet. Check back soon or widen the date range."}
      </Typography>
    </Box>
  );
}

export function EventsLoading() {
  return (
    <Stack spacing={1.5} data-testid="events-loading">
      {[0, 1].map((row) => (
        <Skeleton
          key={row}
          variant="rounded"
          height={72}
          sx={{ bgcolor: "rgba(255,255,255,0.35)", borderRadius: 3 }}
        />
      ))}
    </Stack>
  );
}

function ClubPreviewCard({
  club,
  managerMode,
  devPort,
  setLessonPro,
  setLessonPrice,
  setEventId,
  setGameDelete,
  setGameToDelete,
  setClubId,
  setLeasePrice,
  setGameDate,
  setGamePoloType,
  setGameDivisions,
  weekAtAGlance,
  setEventToEdit,
  setUpdateModal,
  setUpdateLessonModal,
  selectedEventTypes,
  startDate,
  endDate,
  showOnlyBookedLessons,
  setDisplayTournamentModal,
  setLessonDeleteMessage,
  setLessonToDeleteId,
  reload,
  setEventDetails
}) {
  const [proMapping, setProMapping] = useState();
  useEffect(() => {
    const player_fetcher = devPort + "player_list/" + club.value + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, club.value]);
  const [upcomingLessons, setUpcomingLessons] = useState([]);
  const [eventsLoaded, setEventsLoaded] = useState(false);
  useEffect(() => {
    console.log("RELOADing Dates event");
    if (proMapping) {
      getLessonsByClub(
        devPort,
        club.value,
        (lessons) => {
          setUpcomingLessons(lessons);
          setEventsLoaded(true);
        },
        proMapping,
        startDate,
        endDate
      );
    }
  }, [devPort, club, proMapping, startDate, endDate, reload]);

  const cardContent = (
    <Stack>
      <Grid container size={{ xs: 12 }}>
        <h2>{club.label}</h2>
      </Grid>
      {!eventsLoaded && <EventsLoading />}
      {eventsLoaded && upcomingLessons.length === 0 && (
        <NoUpcomingEvents managerMode={managerMode} compact={weekAtAGlance} />
      )}
      {upcomingLessons.length !== 0 && (
        <Stack spacing={2}>
          {upcomingLessons.map((lesson_day) => {
            const dayEvents = (
              <Stack spacing={2}>
                <Typography>
                  {lesson_day.day + " " + lesson_day.date}
                </Typography>
                {lesson_day.lessons.map((lesson) => {
                  return (
                    <GameOrLessonCard
                      lesson_day={lesson_day}
                      lesson={lesson}
                      setLessonDeleteMessage={setLessonDeleteMessage}
                      setLessonToDeleteId={setLessonToDeleteId}
                      managerMode={managerMode}
                      setEventId={setEventId}
                      setLessonPro={setLessonPro}
                      setLessonPrice={setLessonPrice}
                      setGameDelete={setGameDelete}
                      setGameToDelete={setGameToDelete}
                      setClubId={setClubId}
                      clubId={club.value}
                      setLeasePrice={setLeasePrice}
                      setGameDate={setGameDate}
                      setGamePoloType={setGamePoloType}
                      setGameDivisions={setGameDivisions}
                      weekAtAGlance={weekAtAGlance}
                      setEventToEdit={setEventToEdit}
                      setUpdateModal={setUpdateModal}
                      setUpdateLessonModal={setUpdateLessonModal}
                      selectedEventTypes={selectedEventTypes}
                      showOnlyBookedLessons={showOnlyBookedLessons}
                      setDisplayTournamentModal={setDisplayTournamentModal}
                      setEventDetails={setEventDetails}
                    />
                  );
                })}
              </Stack>
            );
            if (weekAtAGlance) {
              return dayEvents;
            }
            return (
              <Paper elevation={24}>
                <Card variant="elevation">
                  <CardContent>{dayEvents}</CardContent>
                </Card>
              </Paper>
            );
          })}
        </Stack>
      )}
    </Stack>
  );

  return weekAtAGlance ? (
    <Paper elevation={24}>
      <Card variant="elevation" key={club.label}>
        <CardContent>{cardContent}</CardContent>
      </Card>
    </Paper>
  ) : (
    cardContent
  );
}

export default ClubPreviewCard;
